// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/home/home.js';
import SignUp from './pages/sign-up/signup.js';
import SignIn from './pages/sign-in/signIn.js';
import OTPVerification from './pages/otp/otp.js';
import Dashboard from './pages/dashboard/dashboard.js';
import Profile from './pages/profile/profile.js';
import Settings from './pages/settings/settings.js';
import Gallery from './pages/gallery/gallery.js';
import About from './pages/about/about.js';
import Contact from './pages/contact/contact.js';
import Privacy from './pages/privacy/privacy.js';
import Terms from './pages/terms/terms.js';
import Explore from './pages/explore/explore.js';
import ResetPassword from './pages/forget-pass/ResetPassword.js';
import RequestPasswordReset from './pages/forget-pass/RequestReset.js';
import Packages from './pages/packages/packages.js';
import PaymentSuccess from './pages/payment/PaymentSuccess';
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            {/* Define your routes here */}
            <Route path="/" element={<Home />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/generate" element={<Dashboard />} />
            <Route path="/otp" element={<OTPVerification />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/image/content/:imageId" element={<Explore />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/forgot-password" element={<RequestPasswordReset />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
